
<mat-sidenav-container class="sidenav-container">
  <mat-sidenav #drawer class="sidenav"
               [attr.role]="(isHandset$ | async) ? 'dialog' : 'navigation'"
               [mode]="(isHandset$ | async) ? 'over' : 'side'"
               [opened]="(isHandset$ | async) === false">
    
    <h1>Form Editor</h1>    

    <mat-list>
      <mat-list-item>
        <span matListItemTitle><strong>Details</strong></span>
        <span matListItemLine>
          PCT: <strong>{{formDefinition?.formPct}}</strong>
          ID: <strong>{{formDefinition?.formId}}</strong>
          HUB: <strong>{{hubId || 'null'}}</strong>
          AGENCY: <strong>{{agencyId || 'null'}}</strong>
        </span>
        <span matListItemLine>
          <a matButton [routerLink]="`/main/form/${pct}/${formId}/${hubId}`" target="_blank">
            <mat-icon>visibility</mat-icon>
            Preview Form
          </a>
        </span>
      </mat-list-item>
      <mat-list-item>
        <span matListItemTitle><strong>UPDATED</strong></span>

      </mat-list-item>
    </mat-list>

    <button matButton="filled" [disabled]="formGroup?.invalid||false" (click)="save()">
      <mat-icon>save</mat-icon>
      <span>Save</span>
    </button>
  </mat-sidenav>

  <mat-sidenav-content>


    @if (isHandset$ | async) {
    <button type="button"
            aria-label="Toggle sidenav"
            matIconButton
            (click)="drawer.toggle()">
      <mat-icon aria-label="Side nav toggle icon">menu</mat-icon>
    </button>
    }
    <h2>{{formDefinition?.defaultFormName}}</h2>
    @if(formGroup){
    <form [formGroup]="formGroup" class="form-container">
      <mat-table [dataSource]="dataSource" class="mat-elevation-z8">

        <ng-container matColumnDef="formOrder">
          <mat-header-cell *matHeaderCellDef> Order</mat-header-cell>
          <mat-cell *matCellDef="let field"> {{field.formOrder}} </mat-cell>
        </ng-container>

        <ng-container matColumnDef="columnName">
          <mat-header-cell *matHeaderCellDef> Column Name</mat-header-cell>
          <mat-cell *matCellDef="let field">
            <mat-form-field>
              <mat-label>Column Name</mat-label>
              <input type="text" matInput placeholder="Column Name" [(ngModel)]="field.columnName" [ngModelOptions]="{standalone: true}">
            </mat-form-field>
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="labelText">
          <mat-header-cell *matHeaderCellDef> Label</mat-header-cell>
          <mat-cell *matCellDef="let field">
            <mat-form-field>
              <mat-label>Label</mat-label>
              <input type="text" matInput placeholder="Label" [(ngModel)]="field.labelText" [ngModelOptions]="{standalone: true}">
            </mat-form-field>
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="labelTextEs">
          <mat-header-cell *matHeaderCellDef> Label ES</mat-header-cell>
          <mat-cell *matCellDef="let field">
            <mat-form-field>
              <mat-label>Label ES</mat-label>
              <input type="text" matInput placeholder="Label ES" [(ngModel)]="field.labelTextEs" [ngModelOptions]="{standalone: true}">
            </mat-form-field>
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="fieldType">
          <mat-header-cell *matHeaderCellDef>Control Type</mat-header-cell>
          <mat-cell *matCellDef="let field">
            <mat-form-field>
              <mat-label>Control Type</mat-label>
              <input type="text" matInput placeholder="Control Type" [(ngModel)]="field.fieldType" [ngModelOptions]="{standalone: true}">
            </mat-form-field>
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="defaultValue">
          <mat-header-cell *matHeaderCellDef>Default Value</mat-header-cell>
          <mat-cell *matCellDef="let field">
            <mat-form-field>
              <input type="text" matInput placeholder="Default Value" [(ngModel)]="field.defaultValue" [ngModelOptions]="{standalone: true}">
            </mat-form-field>
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="isRequired">
          <mat-header-cell *matHeaderCellDef>Required</mat-header-cell>
          <mat-cell *matCellDef="let field">
            <mat-slide-toggle [(ngModel)]="field.isRequired" [ngModelOptions]="{standalone: true}" aria-label="Is required"></mat-slide-toggle>
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="validationRegex">
          <mat-header-cell *matHeaderCellDef>Validation Regex</mat-header-cell>
          <mat-cell *matCellDef="let field">
            <mat-form-field>
              <input type="text" matInput placeholder="Validation Regex" [(ngModel)]="field.validationRegex" [ngModelOptions]="{standalone: true}">
            </mat-form-field>
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="validationRegexErrorMsg">
          <mat-header-cell *matHeaderCellDef>Validation Regex Message</mat-header-cell>
          <mat-cell *matCellDef="let field">
            <mat-form-field>
              <input type="text" matInput placeholder="Validation Regex Message" [(ngModel)]="field.validationRegexErrorMsg" [ngModelOptions]="{standalone: true}">
            </mat-form-field>
          </mat-cell>
        </ng-container>


        <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
        <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>

      </mat-table>
    </form>
    }

    <mat-paginator [length]="length"
                   [pageIndex]="pageIndex"
                   [pageSizeOptions]="pageSizeOptions"
                   showFirstLastButtons
                   aria-label="Select page of periodic elements">
    </mat-paginator>
  </mat-sidenav-content>
</mat-sidenav-container>
